"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLAG_OBJECT = void 0;
var client_1 = require("@apollo/client");
var fragments_1 = require("../fragments");
exports.FLAG_OBJECT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation FlagObject($input: FlagObjectInput!) {\n    flagObject(input: $input) {\n      object {\n        ...FlaggableObject\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation FlagObject($input: FlagObjectInput!) {\n    flagObject(input: $input) {\n      object {\n        ...FlaggableObject\n      }\n    }\n  }\n  ", "\n"])), fragments_1.FLAGGABLE_OBJECT_FRAGMENT);
var templateObject_1;
